import { PERFORMS, CONTRIBUTES } from "@/assets/js/tactics/pitch/responsibilities";
import DefensivePressurePerformance from "./performances/central-midfield/defensive-pressure";
import CreatingChancesPerformance from "./performances/central-midfield/creating-chances";
import PlayingSafePerformance from "./performances/central-midfield/playing-safe";
import AttackingCoverPerformance from "./performances/central-midfield/attacking-cover";
import DefensiveCoverPerformance from "./performances/central-midfield/defensive-cover";
import StretchingPlayPerformance from "./performances/central-midfield/stretching-play";


export default class CentralMidfieldResponsibilityPerformances {
  constructor() {
    this.defensivePressure = new DefensivePressurePerformance();
    this.creatingChances = new CreatingChancesPerformance();
    this.playingSafe = new PlayingSafePerformance();
    this.attackingCover = new AttackingCoverPerformance();
    this.defensiveCover = new DefensiveCoverPerformance();
    this.stretchingPlay = new StretchingPlayPerformance();
  }

  countPerformance(performances) {
    for (const responsibility of Object.keys(performances)) {

      if (performances[responsibility].performs === PERFORMS) {
        this[responsibility].addPerformer(performances[responsibility].atypically);
        continue;
      }
      if (performances[responsibility].performs === CONTRIBUTES) {
        this[responsibility].addContributor(performances[responsibility].atypically);
      }
    }
  }
}
